import styled from "styled-components";

const TextSecondary = styled.div`
  color: ${props => props.theme.darkgrey};
  font-size: 16px;
  font-weight: 300;
`;

export default TextSecondary;
